import {
  DataFromStorageSetter,
  IPendingConfigStorage,
  ISettingsStorage,
} from "@/services/storage/base/storage-abstractions";
import React from "react";
import { PendingConfigStorageMixin } from "@/services/storage/storage-mixins/pending-config-storage-mixin";
import { TextToSpeechConfig } from "@/components/pages/text-to-speech/hooks/use-start-text-to-speech";
import { TextToSpeechSettings } from "@/components/pages/text-to-speech/components/providers/text-to-speech-provider";
import { TextToSpeechSettingsStorageMixin } from "@/services/storage/storage-mixins/settings-mixins/text-to-speech-settings-storage-mixin";

export type TextToSpeechSettingsField = "text" | "voice" | "language";

class TextToSpeechSessionStorage
  implements
    ISettingsStorage<TextToSpeechSettingsField>,
    IPendingConfigStorage<TextToSpeechConfig>,
    DataFromStorageSetter<TextToSpeechSettings>
{
  private storeName = "textToSpeechCache";
  private databaseName = "TextToSpeechDB";

  pendingConfigStorage = new PendingConfigStorageMixin<TextToSpeechConfig>(
    this.storeName,
    this.databaseName,
  );

  settingStorage = new TextToSpeechSettingsStorageMixin(
    this.storeName,
    this.databaseName,
  );

  async setDataFromStorage(
    setSettings: (value: React.SetStateAction<TextToSpeechSettings>) => void,
  ): Promise<void> {
    const sessionSettings = await this.settingStorage.getSettings();
    setSettings((prevState) => ({
      ...prevState,
      text: sessionSettings.text,
      voice: sessionSettings.voice,
      language: sessionSettings.language || "English",
    }));
  }
}

const textToSpeechSessionStorage = new TextToSpeechSessionStorage();
export { textToSpeechSessionStorage };
